import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import { AiOutlineHome, AiFillSafetyCertificate } from "react-icons/ai";
import { MdPrecisionManufacturing, MdDesignServices } from "react-icons/md";
import { FaTools, FaLeaf, FaUsers, FaAward } from "react-icons/fa";
import "./FurnitureWorkshop.css";

function FurnitureWorkshop() {
  return (
    <Container fluid className="about-section furniture-page">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.5em", paddingBottom: "20px" }}>
              Xưởng Sản Xuất <strong className="purple">Kiên Nội Thất</strong>
            </h1>
            
            <Card className="quote-card-view">
              <Card.Body>
                <blockquote className="blockquote mb-0">
                  <p style={{ textAlign: "justify" }}>
                    Chào mừng bạn đến với <span className="purple">Xưởng Sản Xuất Nội Thất Kiên Design</span> - 
                    nơi biến những ý tưởng sáng tạo thành hiện thực với chất lượng hoàn hảo.
                    <br />
                    <br />
                    Với hơn <span className="purple">10 năm kinh nghiệm</span> trong ngành sản xuất nội thất, 
                    chúng tôi tự hào là đối tác tin cậy của hàng trăm khách hàng và dự án lớn nhỏ.
                    <br />
                    <br />
                    Chúng tôi chuyên sản xuất <span className="purple">nội thất cao cấp, bền đẹp</span> và 
                    phù hợp với mọi không gian sống hiện đại.
                  </p>
                </blockquote>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Workshop Features */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={12}>
            <h1 className="project-heading">
              Đặc Điểm <strong className="purple">Nổi Bật</strong>
            </h1>
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={4} className="project-card">
            <Card className="project-card-view">
              <Card.Body>
                <div style={{ textAlign: "center", paddingBottom: "20px" }}>
                  <MdPrecisionManufacturing className="eco-icon eco-feature-icon" style={{ fontSize: "4em" }} />
                </div>
                <Card.Title style={{ textAlign: "center", color: "white" }}>
                  Sản Xuất Hiện Đại
                </Card.Title>
                <Card.Text style={{ textAlign: "justify", color: "white" }}>
                  Sử dụng máy móc hiện đại và công nghệ tiên tiến để đảm bảo độ chính xác và chất lượng 
                  cao trong từng sản phẩm. Quy trình sản xuất được kiểm soát chặt chẽ.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="project-card">
            <Card className="project-card-view">
              <Card.Body>
                <div style={{ textAlign: "center", paddingBottom: "20px" }}>
                  <MdDesignServices className="eco-icon eco-feature-icon" style={{ fontSize: "4em" }} />
                </div>
                <Card.Title style={{ textAlign: "center", color: "white" }}>
                  Thiết Kế Độc Đáo
                </Card.Title>
                <Card.Text style={{ textAlign: "justify", color: "white" }}>
                  Đội ngũ thiết kế giàu kinh nghiệm, luôn sáng tạo và cập nhật xu hướng mới nhất. 
                  Mỗi sản phẩm đều mang dấu ấn riêng biệt và phù hợp với nhu cầu khách hàng.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="project-card">
            <Card className="project-card-view">
              <Card.Body>
                <div style={{ textAlign: "center", paddingBottom: "20px" }}>
                  <FaLeaf className="eco-icon eco-feature-icon" style={{ fontSize: "4em" }} />
                </div>
                <Card.Title style={{ textAlign: "center", color: "white" }}>
                  Thân Thiện Môi Trường
                </Card.Title>
                <Card.Text style={{ textAlign: "justify", color: "white" }}>
                  Cam kết sử dụng vật liệu thân thiện môi trường, gỗ từ nguồn bền vững. 
                  Quy trình sản xuất xanh, không gây ô nhiễm và an toàn cho sức khỏe.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Products & Services */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={12}>
            <h1 className="project-heading">
              Sản Phẩm & <strong className="purple">Dịch Vụ</strong>
            </h1>
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={4} className="project-card">
            <Card className="project-card-view">
              <Card.Body>
                <Card.Title style={{ textAlign: "center", color: "white", marginBottom: "20px" }}>
                  <AiOutlineHome style={{ fontSize: "1.5em", marginRight: "10px" }} />
                  Nội Thất Gia Đình
                </Card.Title>
                <ul style={{ color: "white", textAlign: "left" }}>
                  <li>Bàn ghế phòng khách cao cấp</li>
                  <li>Tủ kệ tivi và kệ sách đa năng</li>
                  <li>Bộ bàn ghế ăn sang trọng</li>
                  <li>Tủ quần áo và giường ngủ</li>
                  <li>Nội thất phòng bếp hiện đại</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="project-card">
            <Card className="project-card-view">
              <Card.Body>
                <Card.Title style={{ textAlign: "center", color: "white", marginBottom: "20px" }}>
                  <FaTools style={{ fontSize: "1.5em", marginRight: "10px" }} />
                  Nội Thất Văn Phòng
                </Card.Title>
                <ul style={{ color: "white", textAlign: "left" }}>
                  <li>Bàn làm việc ergonomic</li>
                  <li>Ghế xoay và ghế họp chuyên nghiệp</li>
                  <li>Tủ tài liệu và kệ hồ sơ</li>
                  <li>Bàn họp và phòng conference</li>
                  <li>Quầy lễ tân và reception</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="project-card">
            <Card className="project-card-view">
              <Card.Body>
                <Card.Title style={{ textAlign: "center", color: "white", marginBottom: "20px" }}>
                  <FaLeaf style={{ fontSize: "1.5em", marginRight: "10px" }} />
                  Nội Thất Chung Cư Cao Cấp
                </Card.Title>
                <ul style={{ color: "white", textAlign: "left" }}>
                  <li>Thiết kế tối ưu không gian nhỏ</li>
                  <li>Nội thất đa chức năng thông minh</li>
                  <li>Tủ âm tường tiết kiệm diện tích</li>
                  <li>Bàn gấp và ghế xếp hiện đại</li>
                  <li>Giải pháp lưu trữ sáng tạo</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Why Choose Us */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={12}>
            <h1 className="project-heading">
              Tại Sao Chọn <strong className="purple">Chúng Tôi?</strong>
            </h1>
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={3} style={{ textAlign: "center", marginBottom: "30px" }}>
            <FaUsers className="eco-icon eco-feature-icon" style={{ fontSize: "3em", marginBottom: "15px" }} />
            <h4 style={{ color: "white" }}>Đội Ngũ Chuyên Nghiệp</h4>
            <p style={{ color: "white" }}>Thợ thủ công lành nghề với kinh nghiệm hơn 15 năm</p>
          </Col>

          <Col md={3} style={{ textAlign: "center", marginBottom: "30px" }}>
            <AiFillSafetyCertificate className="eco-icon eco-feature-icon" style={{ fontSize: "3em", marginBottom: "15px" }} />
            <h4 style={{ color: "white" }}>Chất Lượng Đảm Bảo</h4>
            <p style={{ color: "white" }}>Bảo hành 5 năm và hỗ trợ suốt đời</p>
          </Col>

          <Col md={3} style={{ textAlign: "center", marginBottom: "30px" }}>
            <FaAward className="eco-icon eco-feature-icon" style={{ fontSize: "3em", marginBottom: "15px" }} />
            <h4 style={{ color: "white" }}>Uy Tín Thương Hiệu</h4>
            <p style={{ color: "white" }}>Được tin tưởng bởi hơn 1000+ khách hàng</p>
          </Col>

          <Col md={3} style={{ textAlign: "center", marginBottom: "30px" }}>
            <MdPrecisionManufacturing className="eco-icon eco-feature-icon" style={{ fontSize: "3em", marginBottom: "15px" }} />
            <h4 style={{ color: "white" }}>Giao Hàng Nhanh</h4>
            <p style={{ color: "white" }}>Cam kết giao hàng đúng hẹn và lắp đặt tận nơi</p>
          </Col>
        </Row>

        {/* Contact Information */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={8}>
            <Card className="quote-card-view contact-section">
              <Card.Body>
                <h3 style={{ textAlign: "center", color: "white", marginBottom: "20px" }}>
                  Liên Hệ Tư Vấn & Báo Giá
                </h3>
                <div style={{ color: "white", textAlign: "center" }}>
                  <p><strong>🏭 Xưởng sản xuất:</strong> KCN Canh Nậu - Tây Phương - Hà Nội</p>
                  <p><strong>🏢 Văn phòng:</strong> FLC Garden Đại Mỗ - Hà Nội</p>
                  <p><strong>📞 Hotline:</strong> (+84) 96502 3735</p>
                  <p><strong>✉️ Email:</strong> me@kiennnd.io.vn</p>
                  <p><strong>🌐 Website:</strong> <a href="https://design.kiennd.io.vn" target="_blank" rel="noopener noreferrer" className="eco-link">design.kiennd.io.vn</a></p>
                  <p><strong>💰 Báo giá:</strong> <a href="https://baogia.kiennd.io.vn/" target="_blank" rel="noopener noreferrer" className="eco-link">baogia.kiennd.io.vn</a></p>
                  <p><strong>🕒 Giờ làm việc:</strong> 8:00 - 18:00 (Thứ 2 - Chủ nhật)</p>
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <p className="eco-accent" style={{ fontStyle: "italic" }}>
                    "Biến ước mơ về không gian sống hoàn hảo thành hiện thực!"
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default FurnitureWorkshop;